import React, { useState, useEffect } from 'react';

/**
 * Functional component that initializes the landing page of the form.
 * useEffect hook fires up on every component render.
 *
 * @param {object} props - properties for the header component, only headerText used
 */
const Header = (props) => {
    const [header, setHeader] = useState('');
    const { headerText } = props;

    useEffect(() => {
        setHeader(headerText);
    }, [headerText]);

    return <h2 className="form-signin-title">{header}</h2>;
};

export default Header;
